module.exports = __webpack_public_path__ + "front/img/edm-banner.937753b0.png";